import 'array-flat-polyfill';

import './polyfills';

import React from 'react';
import ReactDOM from 'react-dom';

// import * as serviceWorker from './serviceWorker';
import { getUrlHashParams } from './utils'
import { openIntercom } from './globals-service'
import { setRedirectPage } from './services/redirect-service';
import { storeLoginDetails } from './services/onboarding-service';

import App from './App';

import googleLogo from './images/google-logo.svg';

import 'material-design-icons/iconfont/material-icons.css';

import './app.css';

if (process.env.REACT_APP_ENV !== 'production') {
    const whyDidYouRender = require('@welldone-software/why-did-you-render');

    whyDidYouRender(React);
}

const queryParams = getUrlHashParams();

if ('nref' in queryParams) {
    try {
        window.niftyRef = atob(decodeURIComponent(queryParams.nref));
    } catch (e) {
        console.error(e);
    }
}

if ('action' in queryParams) {
    switch (queryParams.action) {
        case 'login':
            storeLoginDetails(queryParams.teamUrl, queryParams.token);
            setRedirectPage(decodeURIComponent(queryParams.redirect));
            break;

        case 'messageUs':
            openIntercom();
            break;

        default:
            break;
    }
}

ReactDOM.render(
    <App />,
    document.getElementById('root')
);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();
